var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo16 = function SvgInfo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.333 5.333a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0Zm0 2a.667.667 0 0 1 1.333 0v3.333a.667.667 0 0 1-1.333 0V7.333Zm.667 6A5.34 5.34 0 0 1 2.666 8 5.34 5.34 0 0 1 8 2.666 5.34 5.34 0 0 1 13.333 8 5.34 5.34 0 0 1 8 13.333Zm0-12a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333Z",
    fill: "#008545"
  })));
};
export default SvgInfo16;